
import {apiurl} from '@/services/config'

const API_URL = apiurl+ '/backoffice/console/topupchannel'
import {handleResponse} from "@/services/handleresponse";

export const TopupChannelService = {
    getTopupList
}

async function getTopupList () {
    return fetch(API_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token')
        }
    }).then(handleResponse)
        .then(data => {
            return data
        })
}
